// Brand styling for the Clerk sign-in and sign-up widgets on the onboarding
// pages. Passed per component rather than to ClerkProvider, so Clerk UI in the
// dashboard (the user profile modal) keeps its own look apart from the nav
// tweaks in UserProfileModal.
//
// Clerk derives its shades from these, so they must be literal colors rather
// than CSS variables. Keep them in sync with the brand tokens in index.css.
export const onboardingClerkAppearance = {
  variables: {
    colorPrimary: '#2B2B2B', // --color-brand-charcoal
    colorBackground: '#FDFBF9', // --color-brand-cream-100
    colorText: '#2B2B2B', // --color-brand-charcoal
    colorTextSecondary: '#7D7870', // --color-brand-cream-700
    colorInputBackground: '#FFF', // --color-white
    colorInputText: '#2B2B2B', // --color-brand-charcoal
    fontFamily: "'Helvetica Neue', sans-serif",
    borderRadius: '0',
  },
  // Inputs and buttons stay sharp (borderRadius above); the card itself is
  // rounded to match --radius-sm.
  elements: {
    cardBox: { borderRadius: 'var(--radius-sm)' },
    card: { borderRadius: 'var(--radius-sm)' },
  },
};
